import React from 'react';

import { PayOutlet } from 'components';
import { ROUTE_PATH } from 'constants/routes';

export const TechOperatorOrdersPage: React.FC = () => (
  <PayOutlet
    payinTo={ROUTE_PATH.TECH_OPERATOR.PAYIN_ORDERS}
    payoutTo={ROUTE_PATH.TECH_OPERATOR.PAYOUT_ORDERS}
  />
);
